import React, { useEffect, useState } from 'react'
import AbroadInsurance from './AbroadInsurance'
//import { GetAbroadAdditionalServices } from '../cellcomAbroadBlockSlice';
import AbroadScreenIlAddon from './AbroadScreenIlAddon';
import { connect } from 'react-redux';

function AbroadAdditionalServices(props) {


  useEffect(() => {
    //   const data = {
    //       mobile: props.subscriber,
    //       addonsFolderBlockId: props.data.epiStyleInitializationData.addonsPackagesFolderId
    //   };
    // props.GetAbroadAdditionalServices(data).then();

  }, [props.couponAddons]);

  if (props.subscriber != '' && (props.insuranceData?.exist || props.couponAddons?.length > 0)) {
    return (
      <div className='row abroad-insurance-frame'>
        <div className='abroad-additional-services-header'>שירותים נוספים לחו"ל</div>
        {props.insuranceData?.exist && <AbroadInsurance context={props.context} />}
        {props.couponAddons.length > 0 &&
          props.couponAddons.map((el, index) => {
            return <AbroadScreenIlAddon key={index} couponData={el} subscriber={props.subscriber} />
          })}
      </div>

    )
  }
  else {
    return null
  }

}

const mapDispatchToProps = {
  //GetAbroadAdditionalServices,
};
const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    insuranceData: state.cellcomAbroad.abroadPermanentInsuranceSocData,
    couponAddons: state.cellcomAbroad.couponAddons,
    subscriber: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
      ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
      : state.cellcomAbroad.otpData.otpPhone || state.authentication.loginData.userDetails.contactNumber,
    data: state.cellcomAbroad,
    customerType: state.welcomeBlock?.welcomeState?.customerType,
    selectedSubscriber: state.selfcarePage.selectedSubscriber
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AbroadAdditionalServices);
